const semanticClassNames = {
  root: 'social-player-facebook',
  iFrame: 'social-player-facebook__iframe',
} as const;

export default semanticClassNames;
